export function getRequestId(state) {
    return state.requester_id;
}

export function getClientId(state) {
    return state.client_id;
}

